import { useState, useEffect } from "react";

export default function Footer() {
  const [showScroll, setShowScroll] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <footer className="footer" id="footer">

      <div className="footer-container two-col">

        {/* Column 1 */}
        <div className="footer-col">
          <h3 className="logo">Your Health, Our Priority</h3>

          <p>
            At Aeterna Homeo Health, we don’t just treat diseases — we treat people.
            Let us guide you towards a healthier, balanced, and medicine-free life.
          </p>

          <ul className="contact">
            <li>📍 Ambur, Tamilnadu</li>
            <li>📞 (+91) 8925725773</li>
          </ul>
        </div>

        {/* Column 2 */}
        <div className="footer-col">
          <h3>QUICK LINKS</h3>

          <ul className="links">
            <li onClick={() => scrollToSection("home")}>+ Home</li>
            <li onClick={() => scrollToSection("about")}>+ About Us</li>
            <li onClick={() => scrollToSection("approach")}>+ Our Approach</li>
            <li onClick={() => scrollToSection("conditions")}>+ Conditions</li>
            <li onClick={() => scrollToSection("mission")}>+ Mission</li>
            <li onClick={() => scrollToSection("footer")}>+ Contact</li>
          </ul>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© 2026 Aeterna Homeo Health</p>

        <div className="footer-links">
          <span>Terms Of Use</span>
          <span>Privacy Policy</span>
        </div>
      </div>

      {/* Scroll top button */}
      {showScroll && (
        <div className="scroll-top" onClick={scrollToTop}>
          ↑
        </div>
      )}

    </footer>
  );
}

/* Scroll function */
const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};